/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrintRouteImport } from './routes/_print'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedUsuariosRouteImport } from './routes/_authed/usuarios'
import { Route as AuthedSkillsRouteImport } from './routes/_authed/skills'
import { Route as AuthedPerfilRouteImport } from './routes/_authed/perfil'
import { Route as AuthedJuridicoRouteImport } from './routes/_authed/juridico'
import { Route as AuthedHistoryRouteImport } from './routes/_authed/history'
import { Route as AuthedGestaoRouteImport } from './routes/_authed/gestao'
import { Route as AuthedGeoRouteImport } from './routes/_authed/geo'
import { Route as AuthedDiagnosticoRouteImport } from './routes/_authed/diagnostico'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedCrmRouteImport } from './routes/_authed/crm'
import { Route as AuthedCreditoRouteImport } from './routes/_authed/credito'
import { Route as AuthedConfigRouteImport } from './routes/_authed/config'
import { Route as AuthedClientesRouteImport } from './routes/_authed/clientes'
import { Route as AuthedAmbientalRouteImport } from './routes/_authed/ambiental'
import { Route as AuthedAgronomiaRouteImport } from './routes/_authed/agronomia'
import { Route as AuthedAgentsRouteImport } from './routes/_authed/agents'
import { Route as AuthedAgentesRouteImport } from './routes/_authed/agentes'
import { Route as PrintRelatorioOperacaoOpIdRouteImport } from './routes/_print/relatorio-operacao.$opId'
import { Route as AuthedCrmRelatoriosRouteImport } from './routes/_authed/crm_.relatorios'
import { Route as AuthedCrmMinhasTarefasRouteImport } from './routes/_authed/crm_.minhas-tarefas'
import { Route as AuthedCrmListaRouteImport } from './routes/_authed/crm_.lista'
import { Route as AuthedClientesIdRouteImport } from './routes/_authed/clientes_.$id'
import { Route as AuthedAgronomiaVisitaMultiRouteImport } from './routes/_authed/agronomia_.visita-multi'
import { Route as AuthedAgronomiaVisitaRouteImport } from './routes/_authed/agronomia_.visita'
import { Route as AuthedAgronomiaProdutoresRouteImport } from './routes/_authed/agronomia_.produtores'
import { Route as AuthedAgronomiaNovoProdutorRouteImport } from './routes/_authed/agronomia_.novo-produtor'
import { Route as AuthedAgronomiaNovaFazendaRouteImport } from './routes/_authed/agronomia_.nova-fazenda'
import { Route as AuthedAgronomiaInsumosRouteImport } from './routes/_authed/agronomia_.insumos'
import { Route as AuthedAgronomiaCatalogoRouteImport } from './routes/_authed/agronomia_.catalogo'
import { Route as AuthedAgronomiaBancosDeDadosRouteImport } from './routes/_authed/agronomia_.bancos-de-dados'
import { Route as AuthedAgentesVisaoGeralRouteImport } from './routes/_authed/agentes_.visao-geral'
import { Route as AuthedAgentesQualidadeRouteImport } from './routes/_authed/agentes_.qualidade'
import { Route as AuthedAgentesCustoRouteImport } from './routes/_authed/agentes_.custo'
import { Route as AuthedAgentesAutoaprendizadoRouteImport } from './routes/_authed/agentes_.autoaprendizado'
import { Route as AuthedAgentesAgenteRouteImport } from './routes/_authed/agentes_.$agente'
import { Route as AuthedImoveisIdSoloRouteImport } from './routes/_authed/imoveis_.$id_.solo'
import { Route as AuthedCrmRelatoriosOportunidadesRouteImport } from './routes/_authed/crm_.relatorios_.oportunidades'
import { Route as AuthedAgronomiaVisitaIdRouteImport } from './routes/_authed/agronomia_.visita_.$id'
import { Route as AuthedAgronomiaTalhoesIdRouteImport } from './routes/_authed/agronomia_.talhoes_.$id'
import { Route as AuthedAgronomiaProdutoresCpfRouteImport } from './routes/_authed/agronomia_.produtores_.$cpf'
import { Route as AuthedAgronomiaInsumosIdRouteImport } from './routes/_authed/agronomia_.insumos_.$id'
import { Route as AuthedAgronomiaFazendasIdRouteImport } from './routes/_authed/agronomia_.fazendas_.$id'
import { Route as AuthedAgentesAgenteCanalRouteImport } from './routes/_authed/agentes_.$agente_.$canal'
import { Route as AuthedClientesIdRelatorioProdutividadeRouteImport } from './routes/_authed/clientes_.$id_.relatorio.produtividade'
import { Route as AuthedClientesIdRelatorioOrcamentoRouteImport } from './routes/_authed/clientes_.$id_.relatorio.orcamento'
import { Route as AuthedClientesIdRelatorioOperacoesCreditoRouteImport } from './routes/_authed/clientes_.$id_.relatorio.operacoes-credito'
import { Route as AuthedClientesIdRelatorioOnusGravamesRouteImport } from './routes/_authed/clientes_.$id_.relatorio.onus-gravames'
import { Route as AuthedClientesIdRelatorioConformidadeResumidoRouteImport } from './routes/_authed/clientes_.$id_.relatorio.conformidade-resumido'
import { Route as AuthedClientesIdRelatorioConformidadeDocumentalRouteImport } from './routes/_authed/clientes_.$id_.relatorio.conformidade-documental'
import { Route as AuthedAgronomiaManejoIdCatRouteImport } from './routes/_authed/agronomia_.manejo_.$id_.$cat'
import { Route as AuthedAgronomiaFazendasIdVisitaRouteImport } from './routes/_authed/agronomia_.fazendas_.$id_.visita'
import { Route as AuthedAgronomiaFazendasIdRevisarRouteImport } from './routes/_authed/agronomia_.fazendas_.$id_.revisar'
import { Route as AuthedAgronomiaFazendasIdRelatorioRouteImport } from './routes/_authed/agronomia_.fazendas_.$id_.relatorio'
import { Route as AuthedAgronomiaFazendasIdEditarRouteImport } from './routes/_authed/agronomia_.fazendas_.$id_.editar'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrintRoute = PrintRouteImport.update({
  id: '/_print',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsuariosRoute = AuthedUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSkillsRoute = AuthedSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPerfilRoute = AuthedPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedJuridicoRoute = AuthedJuridicoRouteImport.update({
  id: '/juridico',
  path: '/juridico',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHistoryRoute = AuthedHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGestaoRoute = AuthedGestaoRouteImport.update({
  id: '/gestao',
  path: '/gestao',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGeoRoute = AuthedGeoRouteImport.update({
  id: '/geo',
  path: '/geo',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiagnosticoRoute = AuthedDiagnosticoRouteImport.update({
  id: '/diagnostico',
  path: '/diagnostico',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCrmRoute = AuthedCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCreditoRoute = AuthedCreditoRouteImport.update({
  id: '/credito',
  path: '/credito',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfigRoute = AuthedConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClientesRoute = AuthedClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAmbientalRoute = AuthedAmbientalRouteImport.update({
  id: '/ambiental',
  path: '/ambiental',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgronomiaRoute = AuthedAgronomiaRouteImport.update({
  id: '/agronomia',
  path: '/agronomia',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentsRoute = AuthedAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentesRoute = AuthedAgentesRouteImport.update({
  id: '/agentes',
  path: '/agentes',
  getParentRoute: () => AuthedRoute,
} as any)
const PrintRelatorioOperacaoOpIdRoute =
  PrintRelatorioOperacaoOpIdRouteImport.update({
    id: '/relatorio-operacao/$opId',
    path: '/relatorio-operacao/$opId',
    getParentRoute: () => PrintRoute,
  } as any)
const AuthedCrmRelatoriosRoute = AuthedCrmRelatoriosRouteImport.update({
  id: '/crm_/relatorios',
  path: '/crm/relatorios',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCrmMinhasTarefasRoute = AuthedCrmMinhasTarefasRouteImport.update({
  id: '/crm_/minhas-tarefas',
  path: '/crm/minhas-tarefas',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCrmListaRoute = AuthedCrmListaRouteImport.update({
  id: '/crm_/lista',
  path: '/crm/lista',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClientesIdRoute = AuthedClientesIdRouteImport.update({
  id: '/clientes_/$id',
  path: '/clientes/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgronomiaVisitaMultiRoute =
  AuthedAgronomiaVisitaMultiRouteImport.update({
    id: '/agronomia_/visita-multi',
    path: '/agronomia/visita-multi',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaVisitaRoute = AuthedAgronomiaVisitaRouteImport.update({
  id: '/agronomia_/visita',
  path: '/agronomia/visita',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgronomiaProdutoresRoute =
  AuthedAgronomiaProdutoresRouteImport.update({
    id: '/agronomia_/produtores',
    path: '/agronomia/produtores',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaNovoProdutorRoute =
  AuthedAgronomiaNovoProdutorRouteImport.update({
    id: '/agronomia_/novo-produtor',
    path: '/agronomia/novo-produtor',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaNovaFazendaRoute =
  AuthedAgronomiaNovaFazendaRouteImport.update({
    id: '/agronomia_/nova-fazenda',
    path: '/agronomia/nova-fazenda',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaInsumosRoute = AuthedAgronomiaInsumosRouteImport.update({
  id: '/agronomia_/insumos',
  path: '/agronomia/insumos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgronomiaCatalogoRoute = AuthedAgronomiaCatalogoRouteImport.update({
  id: '/agronomia_/catalogo',
  path: '/agronomia/catalogo',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgronomiaBancosDeDadosRoute =
  AuthedAgronomiaBancosDeDadosRouteImport.update({
    id: '/agronomia_/bancos-de-dados',
    path: '/agronomia/bancos-de-dados',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentesVisaoGeralRoute = AuthedAgentesVisaoGeralRouteImport.update({
  id: '/agentes_/visao-geral',
  path: '/agentes/visao-geral',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentesQualidadeRoute = AuthedAgentesQualidadeRouteImport.update({
  id: '/agentes_/qualidade',
  path: '/agentes/qualidade',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentesCustoRoute = AuthedAgentesCustoRouteImport.update({
  id: '/agentes_/custo',
  path: '/agentes/custo',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentesAutoaprendizadoRoute =
  AuthedAgentesAutoaprendizadoRouteImport.update({
    id: '/agentes_/autoaprendizado',
    path: '/agentes/autoaprendizado',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentesAgenteRoute = AuthedAgentesAgenteRouteImport.update({
  id: '/agentes_/$agente',
  path: '/agentes/$agente',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedImoveisIdSoloRoute = AuthedImoveisIdSoloRouteImport.update({
  id: '/imoveis_/$id_/solo',
  path: '/imoveis/$id/solo',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCrmRelatoriosOportunidadesRoute =
  AuthedCrmRelatoriosOportunidadesRouteImport.update({
    id: '/crm_/relatorios_/oportunidades',
    path: '/crm/relatorios/oportunidades',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaVisitaIdRoute = AuthedAgronomiaVisitaIdRouteImport.update({
  id: '/agronomia_/visita_/$id',
  path: '/agronomia/visita/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgronomiaTalhoesIdRoute =
  AuthedAgronomiaTalhoesIdRouteImport.update({
    id: '/agronomia_/talhoes_/$id',
    path: '/agronomia/talhoes/$id',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaProdutoresCpfRoute =
  AuthedAgronomiaProdutoresCpfRouteImport.update({
    id: '/agronomia_/produtores_/$cpf',
    path: '/agronomia/produtores/$cpf',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaInsumosIdRoute =
  AuthedAgronomiaInsumosIdRouteImport.update({
    id: '/agronomia_/insumos_/$id',
    path: '/agronomia/insumos/$id',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaFazendasIdRoute =
  AuthedAgronomiaFazendasIdRouteImport.update({
    id: '/agronomia_/fazendas_/$id',
    path: '/agronomia/fazendas/$id',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentesAgenteCanalRoute =
  AuthedAgentesAgenteCanalRouteImport.update({
    id: '/agentes_/$agente_/$canal',
    path: '/agentes/$agente/$canal',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRelatorioProdutividadeRoute =
  AuthedClientesIdRelatorioProdutividadeRouteImport.update({
    id: '/clientes_/$id_/relatorio/produtividade',
    path: '/clientes/$id/relatorio/produtividade',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRelatorioOrcamentoRoute =
  AuthedClientesIdRelatorioOrcamentoRouteImport.update({
    id: '/clientes_/$id_/relatorio/orcamento',
    path: '/clientes/$id/relatorio/orcamento',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRelatorioOperacoesCreditoRoute =
  AuthedClientesIdRelatorioOperacoesCreditoRouteImport.update({
    id: '/clientes_/$id_/relatorio/operacoes-credito',
    path: '/clientes/$id/relatorio/operacoes-credito',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRelatorioOnusGravamesRoute =
  AuthedClientesIdRelatorioOnusGravamesRouteImport.update({
    id: '/clientes_/$id_/relatorio/onus-gravames',
    path: '/clientes/$id/relatorio/onus-gravames',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRelatorioConformidadeResumidoRoute =
  AuthedClientesIdRelatorioConformidadeResumidoRouteImport.update({
    id: '/clientes_/$id_/relatorio/conformidade-resumido',
    path: '/clientes/$id/relatorio/conformidade-resumido',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRelatorioConformidadeDocumentalRoute =
  AuthedClientesIdRelatorioConformidadeDocumentalRouteImport.update({
    id: '/clientes_/$id_/relatorio/conformidade-documental',
    path: '/clientes/$id/relatorio/conformidade-documental',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaManejoIdCatRoute =
  AuthedAgronomiaManejoIdCatRouteImport.update({
    id: '/agronomia_/manejo_/$id_/$cat',
    path: '/agronomia/manejo/$id/$cat',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaFazendasIdVisitaRoute =
  AuthedAgronomiaFazendasIdVisitaRouteImport.update({
    id: '/agronomia_/fazendas_/$id_/visita',
    path: '/agronomia/fazendas/$id/visita',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaFazendasIdRevisarRoute =
  AuthedAgronomiaFazendasIdRevisarRouteImport.update({
    id: '/agronomia_/fazendas_/$id_/revisar',
    path: '/agronomia/fazendas/$id/revisar',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaFazendasIdRelatorioRoute =
  AuthedAgronomiaFazendasIdRelatorioRouteImport.update({
    id: '/agronomia_/fazendas_/$id_/relatorio',
    path: '/agronomia/fazendas/$id/relatorio',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgronomiaFazendasIdEditarRoute =
  AuthedAgronomiaFazendasIdEditarRouteImport.update({
    id: '/agronomia_/fazendas_/$id_/editar',
    path: '/agronomia/fazendas/$id/editar',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agentes': typeof AuthedAgentesRoute
  '/agents': typeof AuthedAgentsRoute
  '/agronomia': typeof AuthedAgronomiaRoute
  '/ambiental': typeof AuthedAmbientalRoute
  '/clientes': typeof AuthedClientesRoute
  '/config': typeof AuthedConfigRoute
  '/credito': typeof AuthedCreditoRoute
  '/crm': typeof AuthedCrmRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/diagnostico': typeof AuthedDiagnosticoRoute
  '/geo': typeof AuthedGeoRoute
  '/gestao': typeof AuthedGestaoRoute
  '/history': typeof AuthedHistoryRoute
  '/juridico': typeof AuthedJuridicoRoute
  '/perfil': typeof AuthedPerfilRoute
  '/skills': typeof AuthedSkillsRoute
  '/usuarios': typeof AuthedUsuariosRoute
  '/agentes/$agente': typeof AuthedAgentesAgenteRoute
  '/agentes/autoaprendizado': typeof AuthedAgentesAutoaprendizadoRoute
  '/agentes/custo': typeof AuthedAgentesCustoRoute
  '/agentes/qualidade': typeof AuthedAgentesQualidadeRoute
  '/agentes/visao-geral': typeof AuthedAgentesVisaoGeralRoute
  '/agronomia/bancos-de-dados': typeof AuthedAgronomiaBancosDeDadosRoute
  '/agronomia/catalogo': typeof AuthedAgronomiaCatalogoRoute
  '/agronomia/insumos': typeof AuthedAgronomiaInsumosRoute
  '/agronomia/nova-fazenda': typeof AuthedAgronomiaNovaFazendaRoute
  '/agronomia/novo-produtor': typeof AuthedAgronomiaNovoProdutorRoute
  '/agronomia/produtores': typeof AuthedAgronomiaProdutoresRoute
  '/agronomia/visita': typeof AuthedAgronomiaVisitaRoute
  '/agronomia/visita-multi': typeof AuthedAgronomiaVisitaMultiRoute
  '/clientes/$id': typeof AuthedClientesIdRoute
  '/crm/lista': typeof AuthedCrmListaRoute
  '/crm/minhas-tarefas': typeof AuthedCrmMinhasTarefasRoute
  '/crm/relatorios': typeof AuthedCrmRelatoriosRoute
  '/relatorio-operacao/$opId': typeof PrintRelatorioOperacaoOpIdRoute
  '/agentes/$agente/$canal': typeof AuthedAgentesAgenteCanalRoute
  '/agronomia/fazendas/$id': typeof AuthedAgronomiaFazendasIdRoute
  '/agronomia/insumos/$id': typeof AuthedAgronomiaInsumosIdRoute
  '/agronomia/produtores/$cpf': typeof AuthedAgronomiaProdutoresCpfRoute
  '/agronomia/talhoes/$id': typeof AuthedAgronomiaTalhoesIdRoute
  '/agronomia/visita/$id': typeof AuthedAgronomiaVisitaIdRoute
  '/crm/relatorios/oportunidades': typeof AuthedCrmRelatoriosOportunidadesRoute
  '/imoveis/$id/solo': typeof AuthedImoveisIdSoloRoute
  '/agronomia/fazendas/$id/editar': typeof AuthedAgronomiaFazendasIdEditarRoute
  '/agronomia/fazendas/$id/relatorio': typeof AuthedAgronomiaFazendasIdRelatorioRoute
  '/agronomia/fazendas/$id/revisar': typeof AuthedAgronomiaFazendasIdRevisarRoute
  '/agronomia/fazendas/$id/visita': typeof AuthedAgronomiaFazendasIdVisitaRoute
  '/agronomia/manejo/$id/$cat': typeof AuthedAgronomiaManejoIdCatRoute
  '/clientes/$id/relatorio/conformidade-documental': typeof AuthedClientesIdRelatorioConformidadeDocumentalRoute
  '/clientes/$id/relatorio/conformidade-resumido': typeof AuthedClientesIdRelatorioConformidadeResumidoRoute
  '/clientes/$id/relatorio/onus-gravames': typeof AuthedClientesIdRelatorioOnusGravamesRoute
  '/clientes/$id/relatorio/operacoes-credito': typeof AuthedClientesIdRelatorioOperacoesCreditoRoute
  '/clientes/$id/relatorio/orcamento': typeof AuthedClientesIdRelatorioOrcamentoRoute
  '/clientes/$id/relatorio/produtividade': typeof AuthedClientesIdRelatorioProdutividadeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agentes': typeof AuthedAgentesRoute
  '/agents': typeof AuthedAgentsRoute
  '/agronomia': typeof AuthedAgronomiaRoute
  '/ambiental': typeof AuthedAmbientalRoute
  '/clientes': typeof AuthedClientesRoute
  '/config': typeof AuthedConfigRoute
  '/credito': typeof AuthedCreditoRoute
  '/crm': typeof AuthedCrmRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/diagnostico': typeof AuthedDiagnosticoRoute
  '/geo': typeof AuthedGeoRoute
  '/gestao': typeof AuthedGestaoRoute
  '/history': typeof AuthedHistoryRoute
  '/juridico': typeof AuthedJuridicoRoute
  '/perfil': typeof AuthedPerfilRoute
  '/skills': typeof AuthedSkillsRoute
  '/usuarios': typeof AuthedUsuariosRoute
  '/agentes/$agente': typeof AuthedAgentesAgenteRoute
  '/agentes/autoaprendizado': typeof AuthedAgentesAutoaprendizadoRoute
  '/agentes/custo': typeof AuthedAgentesCustoRoute
  '/agentes/qualidade': typeof AuthedAgentesQualidadeRoute
  '/agentes/visao-geral': typeof AuthedAgentesVisaoGeralRoute
  '/agronomia/bancos-de-dados': typeof AuthedAgronomiaBancosDeDadosRoute
  '/agronomia/catalogo': typeof AuthedAgronomiaCatalogoRoute
  '/agronomia/insumos': typeof AuthedAgronomiaInsumosRoute
  '/agronomia/nova-fazenda': typeof AuthedAgronomiaNovaFazendaRoute
  '/agronomia/novo-produtor': typeof AuthedAgronomiaNovoProdutorRoute
  '/agronomia/produtores': typeof AuthedAgronomiaProdutoresRoute
  '/agronomia/visita': typeof AuthedAgronomiaVisitaRoute
  '/agronomia/visita-multi': typeof AuthedAgronomiaVisitaMultiRoute
  '/clientes/$id': typeof AuthedClientesIdRoute
  '/crm/lista': typeof AuthedCrmListaRoute
  '/crm/minhas-tarefas': typeof AuthedCrmMinhasTarefasRoute
  '/crm/relatorios': typeof AuthedCrmRelatoriosRoute
  '/relatorio-operacao/$opId': typeof PrintRelatorioOperacaoOpIdRoute
  '/agentes/$agente/$canal': typeof AuthedAgentesAgenteCanalRoute
  '/agronomia/fazendas/$id': typeof AuthedAgronomiaFazendasIdRoute
  '/agronomia/insumos/$id': typeof AuthedAgronomiaInsumosIdRoute
  '/agronomia/produtores/$cpf': typeof AuthedAgronomiaProdutoresCpfRoute
  '/agronomia/talhoes/$id': typeof AuthedAgronomiaTalhoesIdRoute
  '/agronomia/visita/$id': typeof AuthedAgronomiaVisitaIdRoute
  '/crm/relatorios/oportunidades': typeof AuthedCrmRelatoriosOportunidadesRoute
  '/imoveis/$id/solo': typeof AuthedImoveisIdSoloRoute
  '/agronomia/fazendas/$id/editar': typeof AuthedAgronomiaFazendasIdEditarRoute
  '/agronomia/fazendas/$id/relatorio': typeof AuthedAgronomiaFazendasIdRelatorioRoute
  '/agronomia/fazendas/$id/revisar': typeof AuthedAgronomiaFazendasIdRevisarRoute
  '/agronomia/fazendas/$id/visita': typeof AuthedAgronomiaFazendasIdVisitaRoute
  '/agronomia/manejo/$id/$cat': typeof AuthedAgronomiaManejoIdCatRoute
  '/clientes/$id/relatorio/conformidade-documental': typeof AuthedClientesIdRelatorioConformidadeDocumentalRoute
  '/clientes/$id/relatorio/conformidade-resumido': typeof AuthedClientesIdRelatorioConformidadeResumidoRoute
  '/clientes/$id/relatorio/onus-gravames': typeof AuthedClientesIdRelatorioOnusGravamesRoute
  '/clientes/$id/relatorio/operacoes-credito': typeof AuthedClientesIdRelatorioOperacoesCreditoRoute
  '/clientes/$id/relatorio/orcamento': typeof AuthedClientesIdRelatorioOrcamentoRoute
  '/clientes/$id/relatorio/produtividade': typeof AuthedClientesIdRelatorioProdutividadeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_print': typeof PrintRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/agentes': typeof AuthedAgentesRoute
  '/_authed/agents': typeof AuthedAgentsRoute
  '/_authed/agronomia': typeof AuthedAgronomiaRoute
  '/_authed/ambiental': typeof AuthedAmbientalRoute
  '/_authed/clientes': typeof AuthedClientesRoute
  '/_authed/config': typeof AuthedConfigRoute
  '/_authed/credito': typeof AuthedCreditoRoute
  '/_authed/crm': typeof AuthedCrmRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/diagnostico': typeof AuthedDiagnosticoRoute
  '/_authed/geo': typeof AuthedGeoRoute
  '/_authed/gestao': typeof AuthedGestaoRoute
  '/_authed/history': typeof AuthedHistoryRoute
  '/_authed/juridico': typeof AuthedJuridicoRoute
  '/_authed/perfil': typeof AuthedPerfilRoute
  '/_authed/skills': typeof AuthedSkillsRoute
  '/_authed/usuarios': typeof AuthedUsuariosRoute
  '/_authed/agentes_/$agente': typeof AuthedAgentesAgenteRoute
  '/_authed/agentes_/autoaprendizado': typeof AuthedAgentesAutoaprendizadoRoute
  '/_authed/agentes_/custo': typeof AuthedAgentesCustoRoute
  '/_authed/agentes_/qualidade': typeof AuthedAgentesQualidadeRoute
  '/_authed/agentes_/visao-geral': typeof AuthedAgentesVisaoGeralRoute
  '/_authed/agronomia_/bancos-de-dados': typeof AuthedAgronomiaBancosDeDadosRoute
  '/_authed/agronomia_/catalogo': typeof AuthedAgronomiaCatalogoRoute
  '/_authed/agronomia_/insumos': typeof AuthedAgronomiaInsumosRoute
  '/_authed/agronomia_/nova-fazenda': typeof AuthedAgronomiaNovaFazendaRoute
  '/_authed/agronomia_/novo-produtor': typeof AuthedAgronomiaNovoProdutorRoute
  '/_authed/agronomia_/produtores': typeof AuthedAgronomiaProdutoresRoute
  '/_authed/agronomia_/visita': typeof AuthedAgronomiaVisitaRoute
  '/_authed/agronomia_/visita-multi': typeof AuthedAgronomiaVisitaMultiRoute
  '/_authed/clientes_/$id': typeof AuthedClientesIdRoute
  '/_authed/crm_/lista': typeof AuthedCrmListaRoute
  '/_authed/crm_/minhas-tarefas': typeof AuthedCrmMinhasTarefasRoute
  '/_authed/crm_/relatorios': typeof AuthedCrmRelatoriosRoute
  '/_print/relatorio-operacao/$opId': typeof PrintRelatorioOperacaoOpIdRoute
  '/_authed/agentes_/$agente_/$canal': typeof AuthedAgentesAgenteCanalRoute
  '/_authed/agronomia_/fazendas_/$id': typeof AuthedAgronomiaFazendasIdRoute
  '/_authed/agronomia_/insumos_/$id': typeof AuthedAgronomiaInsumosIdRoute
  '/_authed/agronomia_/produtores_/$cpf': typeof AuthedAgronomiaProdutoresCpfRoute
  '/_authed/agronomia_/talhoes_/$id': typeof AuthedAgronomiaTalhoesIdRoute
  '/_authed/agronomia_/visita_/$id': typeof AuthedAgronomiaVisitaIdRoute
  '/_authed/crm_/relatorios_/oportunidades': typeof AuthedCrmRelatoriosOportunidadesRoute
  '/_authed/imoveis_/$id_/solo': typeof AuthedImoveisIdSoloRoute
  '/_authed/agronomia_/fazendas_/$id_/editar': typeof AuthedAgronomiaFazendasIdEditarRoute
  '/_authed/agronomia_/fazendas_/$id_/relatorio': typeof AuthedAgronomiaFazendasIdRelatorioRoute
  '/_authed/agronomia_/fazendas_/$id_/revisar': typeof AuthedAgronomiaFazendasIdRevisarRoute
  '/_authed/agronomia_/fazendas_/$id_/visita': typeof AuthedAgronomiaFazendasIdVisitaRoute
  '/_authed/agronomia_/manejo_/$id_/$cat': typeof AuthedAgronomiaManejoIdCatRoute
  '/_authed/clientes_/$id_/relatorio/conformidade-documental': typeof AuthedClientesIdRelatorioConformidadeDocumentalRoute
  '/_authed/clientes_/$id_/relatorio/conformidade-resumido': typeof AuthedClientesIdRelatorioConformidadeResumidoRoute
  '/_authed/clientes_/$id_/relatorio/onus-gravames': typeof AuthedClientesIdRelatorioOnusGravamesRoute
  '/_authed/clientes_/$id_/relatorio/operacoes-credito': typeof AuthedClientesIdRelatorioOperacoesCreditoRoute
  '/_authed/clientes_/$id_/relatorio/orcamento': typeof AuthedClientesIdRelatorioOrcamentoRoute
  '/_authed/clientes_/$id_/relatorio/produtividade': typeof AuthedClientesIdRelatorioProdutividadeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/agentes'
    | '/agents'
    | '/agronomia'
    | '/ambiental'
    | '/clientes'
    | '/config'
    | '/credito'
    | '/crm'
    | '/dashboard'
    | '/diagnostico'
    | '/geo'
    | '/gestao'
    | '/history'
    | '/juridico'
    | '/perfil'
    | '/skills'
    | '/usuarios'
    | '/agentes/$agente'
    | '/agentes/autoaprendizado'
    | '/agentes/custo'
    | '/agentes/qualidade'
    | '/agentes/visao-geral'
    | '/agronomia/bancos-de-dados'
    | '/agronomia/catalogo'
    | '/agronomia/insumos'
    | '/agronomia/nova-fazenda'
    | '/agronomia/novo-produtor'
    | '/agronomia/produtores'
    | '/agronomia/visita'
    | '/agronomia/visita-multi'
    | '/clientes/$id'
    | '/crm/lista'
    | '/crm/minhas-tarefas'
    | '/crm/relatorios'
    | '/relatorio-operacao/$opId'
    | '/agentes/$agente/$canal'
    | '/agronomia/fazendas/$id'
    | '/agronomia/insumos/$id'
    | '/agronomia/produtores/$cpf'
    | '/agronomia/talhoes/$id'
    | '/agronomia/visita/$id'
    | '/crm/relatorios/oportunidades'
    | '/imoveis/$id/solo'
    | '/agronomia/fazendas/$id/editar'
    | '/agronomia/fazendas/$id/relatorio'
    | '/agronomia/fazendas/$id/revisar'
    | '/agronomia/fazendas/$id/visita'
    | '/agronomia/manejo/$id/$cat'
    | '/clientes/$id/relatorio/conformidade-documental'
    | '/clientes/$id/relatorio/conformidade-resumido'
    | '/clientes/$id/relatorio/onus-gravames'
    | '/clientes/$id/relatorio/operacoes-credito'
    | '/clientes/$id/relatorio/orcamento'
    | '/clientes/$id/relatorio/produtividade'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/agentes'
    | '/agents'
    | '/agronomia'
    | '/ambiental'
    | '/clientes'
    | '/config'
    | '/credito'
    | '/crm'
    | '/dashboard'
    | '/diagnostico'
    | '/geo'
    | '/gestao'
    | '/history'
    | '/juridico'
    | '/perfil'
    | '/skills'
    | '/usuarios'
    | '/agentes/$agente'
    | '/agentes/autoaprendizado'
    | '/agentes/custo'
    | '/agentes/qualidade'
    | '/agentes/visao-geral'
    | '/agronomia/bancos-de-dados'
    | '/agronomia/catalogo'
    | '/agronomia/insumos'
    | '/agronomia/nova-fazenda'
    | '/agronomia/novo-produtor'
    | '/agronomia/produtores'
    | '/agronomia/visita'
    | '/agronomia/visita-multi'
    | '/clientes/$id'
    | '/crm/lista'
    | '/crm/minhas-tarefas'
    | '/crm/relatorios'
    | '/relatorio-operacao/$opId'
    | '/agentes/$agente/$canal'
    | '/agronomia/fazendas/$id'
    | '/agronomia/insumos/$id'
    | '/agronomia/produtores/$cpf'
    | '/agronomia/talhoes/$id'
    | '/agronomia/visita/$id'
    | '/crm/relatorios/oportunidades'
    | '/imoveis/$id/solo'
    | '/agronomia/fazendas/$id/editar'
    | '/agronomia/fazendas/$id/relatorio'
    | '/agronomia/fazendas/$id/revisar'
    | '/agronomia/fazendas/$id/visita'
    | '/agronomia/manejo/$id/$cat'
    | '/clientes/$id/relatorio/conformidade-documental'
    | '/clientes/$id/relatorio/conformidade-resumido'
    | '/clientes/$id/relatorio/onus-gravames'
    | '/clientes/$id/relatorio/operacoes-credito'
    | '/clientes/$id/relatorio/orcamento'
    | '/clientes/$id/relatorio/produtividade'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/_print'
    | '/login'
    | '/_authed/agentes'
    | '/_authed/agents'
    | '/_authed/agronomia'
    | '/_authed/ambiental'
    | '/_authed/clientes'
    | '/_authed/config'
    | '/_authed/credito'
    | '/_authed/crm'
    | '/_authed/dashboard'
    | '/_authed/diagnostico'
    | '/_authed/geo'
    | '/_authed/gestao'
    | '/_authed/history'
    | '/_authed/juridico'
    | '/_authed/perfil'
    | '/_authed/skills'
    | '/_authed/usuarios'
    | '/_authed/agentes_/$agente'
    | '/_authed/agentes_/autoaprendizado'
    | '/_authed/agentes_/custo'
    | '/_authed/agentes_/qualidade'
    | '/_authed/agentes_/visao-geral'
    | '/_authed/agronomia_/bancos-de-dados'
    | '/_authed/agronomia_/catalogo'
    | '/_authed/agronomia_/insumos'
    | '/_authed/agronomia_/nova-fazenda'
    | '/_authed/agronomia_/novo-produtor'
    | '/_authed/agronomia_/produtores'
    | '/_authed/agronomia_/visita'
    | '/_authed/agronomia_/visita-multi'
    | '/_authed/clientes_/$id'
    | '/_authed/crm_/lista'
    | '/_authed/crm_/minhas-tarefas'
    | '/_authed/crm_/relatorios'
    | '/_print/relatorio-operacao/$opId'
    | '/_authed/agentes_/$agente_/$canal'
    | '/_authed/agronomia_/fazendas_/$id'
    | '/_authed/agronomia_/insumos_/$id'
    | '/_authed/agronomia_/produtores_/$cpf'
    | '/_authed/agronomia_/talhoes_/$id'
    | '/_authed/agronomia_/visita_/$id'
    | '/_authed/crm_/relatorios_/oportunidades'
    | '/_authed/imoveis_/$id_/solo'
    | '/_authed/agronomia_/fazendas_/$id_/editar'
    | '/_authed/agronomia_/fazendas_/$id_/relatorio'
    | '/_authed/agronomia_/fazendas_/$id_/revisar'
    | '/_authed/agronomia_/fazendas_/$id_/visita'
    | '/_authed/agronomia_/manejo_/$id_/$cat'
    | '/_authed/clientes_/$id_/relatorio/conformidade-documental'
    | '/_authed/clientes_/$id_/relatorio/conformidade-resumido'
    | '/_authed/clientes_/$id_/relatorio/onus-gravames'
    | '/_authed/clientes_/$id_/relatorio/operacoes-credito'
    | '/_authed/clientes_/$id_/relatorio/orcamento'
    | '/_authed/clientes_/$id_/relatorio/produtividade'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  PrintRoute: typeof PrintRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_print': {
      id: '/_print'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/usuarios': {
      id: '/_authed/usuarios'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AuthedUsuariosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/skills': {
      id: '/_authed/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthedSkillsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/perfil': {
      id: '/_authed/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthedPerfilRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/juridico': {
      id: '/_authed/juridico'
      path: '/juridico'
      fullPath: '/juridico'
      preLoaderRoute: typeof AuthedJuridicoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/history': {
      id: '/_authed/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AuthedHistoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gestao': {
      id: '/_authed/gestao'
      path: '/gestao'
      fullPath: '/gestao'
      preLoaderRoute: typeof AuthedGestaoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/geo': {
      id: '/_authed/geo'
      path: '/geo'
      fullPath: '/geo'
      preLoaderRoute: typeof AuthedGeoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/diagnostico': {
      id: '/_authed/diagnostico'
      path: '/diagnostico'
      fullPath: '/diagnostico'
      preLoaderRoute: typeof AuthedDiagnosticoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/crm': {
      id: '/_authed/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof AuthedCrmRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/credito': {
      id: '/_authed/credito'
      path: '/credito'
      fullPath: '/credito'
      preLoaderRoute: typeof AuthedCreditoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/config': {
      id: '/_authed/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof AuthedConfigRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes': {
      id: '/_authed/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AuthedClientesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ambiental': {
      id: '/_authed/ambiental'
      path: '/ambiental'
      fullPath: '/ambiental'
      preLoaderRoute: typeof AuthedAmbientalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia': {
      id: '/_authed/agronomia'
      path: '/agronomia'
      fullPath: '/agronomia'
      preLoaderRoute: typeof AuthedAgronomiaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agents': {
      id: '/_authed/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthedAgentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes': {
      id: '/_authed/agentes'
      path: '/agentes'
      fullPath: '/agentes'
      preLoaderRoute: typeof AuthedAgentesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_print/relatorio-operacao/$opId': {
      id: '/_print/relatorio-operacao/$opId'
      path: '/relatorio-operacao/$opId'
      fullPath: '/relatorio-operacao/$opId'
      preLoaderRoute: typeof PrintRelatorioOperacaoOpIdRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_authed/crm_/relatorios': {
      id: '/_authed/crm_/relatorios'
      path: '/crm/relatorios'
      fullPath: '/crm/relatorios'
      preLoaderRoute: typeof AuthedCrmRelatoriosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/crm_/minhas-tarefas': {
      id: '/_authed/crm_/minhas-tarefas'
      path: '/crm/minhas-tarefas'
      fullPath: '/crm/minhas-tarefas'
      preLoaderRoute: typeof AuthedCrmMinhasTarefasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/crm_/lista': {
      id: '/_authed/crm_/lista'
      path: '/crm/lista'
      fullPath: '/crm/lista'
      preLoaderRoute: typeof AuthedCrmListaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id': {
      id: '/_authed/clientes_/$id'
      path: '/clientes/$id'
      fullPath: '/clientes/$id'
      preLoaderRoute: typeof AuthedClientesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/visita-multi': {
      id: '/_authed/agronomia_/visita-multi'
      path: '/agronomia/visita-multi'
      fullPath: '/agronomia/visita-multi'
      preLoaderRoute: typeof AuthedAgronomiaVisitaMultiRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/visita': {
      id: '/_authed/agronomia_/visita'
      path: '/agronomia/visita'
      fullPath: '/agronomia/visita'
      preLoaderRoute: typeof AuthedAgronomiaVisitaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/produtores': {
      id: '/_authed/agronomia_/produtores'
      path: '/agronomia/produtores'
      fullPath: '/agronomia/produtores'
      preLoaderRoute: typeof AuthedAgronomiaProdutoresRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/novo-produtor': {
      id: '/_authed/agronomia_/novo-produtor'
      path: '/agronomia/novo-produtor'
      fullPath: '/agronomia/novo-produtor'
      preLoaderRoute: typeof AuthedAgronomiaNovoProdutorRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/nova-fazenda': {
      id: '/_authed/agronomia_/nova-fazenda'
      path: '/agronomia/nova-fazenda'
      fullPath: '/agronomia/nova-fazenda'
      preLoaderRoute: typeof AuthedAgronomiaNovaFazendaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/insumos': {
      id: '/_authed/agronomia_/insumos'
      path: '/agronomia/insumos'
      fullPath: '/agronomia/insumos'
      preLoaderRoute: typeof AuthedAgronomiaInsumosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/catalogo': {
      id: '/_authed/agronomia_/catalogo'
      path: '/agronomia/catalogo'
      fullPath: '/agronomia/catalogo'
      preLoaderRoute: typeof AuthedAgronomiaCatalogoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/bancos-de-dados': {
      id: '/_authed/agronomia_/bancos-de-dados'
      path: '/agronomia/bancos-de-dados'
      fullPath: '/agronomia/bancos-de-dados'
      preLoaderRoute: typeof AuthedAgronomiaBancosDeDadosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes_/visao-geral': {
      id: '/_authed/agentes_/visao-geral'
      path: '/agentes/visao-geral'
      fullPath: '/agentes/visao-geral'
      preLoaderRoute: typeof AuthedAgentesVisaoGeralRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes_/qualidade': {
      id: '/_authed/agentes_/qualidade'
      path: '/agentes/qualidade'
      fullPath: '/agentes/qualidade'
      preLoaderRoute: typeof AuthedAgentesQualidadeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes_/custo': {
      id: '/_authed/agentes_/custo'
      path: '/agentes/custo'
      fullPath: '/agentes/custo'
      preLoaderRoute: typeof AuthedAgentesCustoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes_/autoaprendizado': {
      id: '/_authed/agentes_/autoaprendizado'
      path: '/agentes/autoaprendizado'
      fullPath: '/agentes/autoaprendizado'
      preLoaderRoute: typeof AuthedAgentesAutoaprendizadoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes_/$agente': {
      id: '/_authed/agentes_/$agente'
      path: '/agentes/$agente'
      fullPath: '/agentes/$agente'
      preLoaderRoute: typeof AuthedAgentesAgenteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/imoveis_/$id_/solo': {
      id: '/_authed/imoveis_/$id_/solo'
      path: '/imoveis/$id/solo'
      fullPath: '/imoveis/$id/solo'
      preLoaderRoute: typeof AuthedImoveisIdSoloRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/crm_/relatorios_/oportunidades': {
      id: '/_authed/crm_/relatorios_/oportunidades'
      path: '/crm/relatorios/oportunidades'
      fullPath: '/crm/relatorios/oportunidades'
      preLoaderRoute: typeof AuthedCrmRelatoriosOportunidadesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/visita_/$id': {
      id: '/_authed/agronomia_/visita_/$id'
      path: '/agronomia/visita/$id'
      fullPath: '/agronomia/visita/$id'
      preLoaderRoute: typeof AuthedAgronomiaVisitaIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/talhoes_/$id': {
      id: '/_authed/agronomia_/talhoes_/$id'
      path: '/agronomia/talhoes/$id'
      fullPath: '/agronomia/talhoes/$id'
      preLoaderRoute: typeof AuthedAgronomiaTalhoesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/produtores_/$cpf': {
      id: '/_authed/agronomia_/produtores_/$cpf'
      path: '/agronomia/produtores/$cpf'
      fullPath: '/agronomia/produtores/$cpf'
      preLoaderRoute: typeof AuthedAgronomiaProdutoresCpfRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/insumos_/$id': {
      id: '/_authed/agronomia_/insumos_/$id'
      path: '/agronomia/insumos/$id'
      fullPath: '/agronomia/insumos/$id'
      preLoaderRoute: typeof AuthedAgronomiaInsumosIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/fazendas_/$id': {
      id: '/_authed/agronomia_/fazendas_/$id'
      path: '/agronomia/fazendas/$id'
      fullPath: '/agronomia/fazendas/$id'
      preLoaderRoute: typeof AuthedAgronomiaFazendasIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agentes_/$agente_/$canal': {
      id: '/_authed/agentes_/$agente_/$canal'
      path: '/agentes/$agente/$canal'
      fullPath: '/agentes/$agente/$canal'
      preLoaderRoute: typeof AuthedAgentesAgenteCanalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id_/relatorio/produtividade': {
      id: '/_authed/clientes_/$id_/relatorio/produtividade'
      path: '/clientes/$id/relatorio/produtividade'
      fullPath: '/clientes/$id/relatorio/produtividade'
      preLoaderRoute: typeof AuthedClientesIdRelatorioProdutividadeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id_/relatorio/orcamento': {
      id: '/_authed/clientes_/$id_/relatorio/orcamento'
      path: '/clientes/$id/relatorio/orcamento'
      fullPath: '/clientes/$id/relatorio/orcamento'
      preLoaderRoute: typeof AuthedClientesIdRelatorioOrcamentoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id_/relatorio/operacoes-credito': {
      id: '/_authed/clientes_/$id_/relatorio/operacoes-credito'
      path: '/clientes/$id/relatorio/operacoes-credito'
      fullPath: '/clientes/$id/relatorio/operacoes-credito'
      preLoaderRoute: typeof AuthedClientesIdRelatorioOperacoesCreditoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id_/relatorio/onus-gravames': {
      id: '/_authed/clientes_/$id_/relatorio/onus-gravames'
      path: '/clientes/$id/relatorio/onus-gravames'
      fullPath: '/clientes/$id/relatorio/onus-gravames'
      preLoaderRoute: typeof AuthedClientesIdRelatorioOnusGravamesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id_/relatorio/conformidade-resumido': {
      id: '/_authed/clientes_/$id_/relatorio/conformidade-resumido'
      path: '/clientes/$id/relatorio/conformidade-resumido'
      fullPath: '/clientes/$id/relatorio/conformidade-resumido'
      preLoaderRoute: typeof AuthedClientesIdRelatorioConformidadeResumidoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id_/relatorio/conformidade-documental': {
      id: '/_authed/clientes_/$id_/relatorio/conformidade-documental'
      path: '/clientes/$id/relatorio/conformidade-documental'
      fullPath: '/clientes/$id/relatorio/conformidade-documental'
      preLoaderRoute: typeof AuthedClientesIdRelatorioConformidadeDocumentalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/manejo_/$id_/$cat': {
      id: '/_authed/agronomia_/manejo_/$id_/$cat'
      path: '/agronomia/manejo/$id/$cat'
      fullPath: '/agronomia/manejo/$id/$cat'
      preLoaderRoute: typeof AuthedAgronomiaManejoIdCatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/fazendas_/$id_/visita': {
      id: '/_authed/agronomia_/fazendas_/$id_/visita'
      path: '/agronomia/fazendas/$id/visita'
      fullPath: '/agronomia/fazendas/$id/visita'
      preLoaderRoute: typeof AuthedAgronomiaFazendasIdVisitaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/fazendas_/$id_/revisar': {
      id: '/_authed/agronomia_/fazendas_/$id_/revisar'
      path: '/agronomia/fazendas/$id/revisar'
      fullPath: '/agronomia/fazendas/$id/revisar'
      preLoaderRoute: typeof AuthedAgronomiaFazendasIdRevisarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/fazendas_/$id_/relatorio': {
      id: '/_authed/agronomia_/fazendas_/$id_/relatorio'
      path: '/agronomia/fazendas/$id/relatorio'
      fullPath: '/agronomia/fazendas/$id/relatorio'
      preLoaderRoute: typeof AuthedAgronomiaFazendasIdRelatorioRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agronomia_/fazendas_/$id_/editar': {
      id: '/_authed/agronomia_/fazendas_/$id_/editar'
      path: '/agronomia/fazendas/$id/editar'
      fullPath: '/agronomia/fazendas/$id/editar'
      preLoaderRoute: typeof AuthedAgronomiaFazendasIdEditarRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAgentesRoute: typeof AuthedAgentesRoute
  AuthedAgentsRoute: typeof AuthedAgentsRoute
  AuthedAgronomiaRoute: typeof AuthedAgronomiaRoute
  AuthedAmbientalRoute: typeof AuthedAmbientalRoute
  AuthedClientesRoute: typeof AuthedClientesRoute
  AuthedConfigRoute: typeof AuthedConfigRoute
  AuthedCreditoRoute: typeof AuthedCreditoRoute
  AuthedCrmRoute: typeof AuthedCrmRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDiagnosticoRoute: typeof AuthedDiagnosticoRoute
  AuthedGeoRoute: typeof AuthedGeoRoute
  AuthedGestaoRoute: typeof AuthedGestaoRoute
  AuthedHistoryRoute: typeof AuthedHistoryRoute
  AuthedJuridicoRoute: typeof AuthedJuridicoRoute
  AuthedPerfilRoute: typeof AuthedPerfilRoute
  AuthedSkillsRoute: typeof AuthedSkillsRoute
  AuthedUsuariosRoute: typeof AuthedUsuariosRoute
  AuthedAgentesAgenteRoute: typeof AuthedAgentesAgenteRoute
  AuthedAgentesAutoaprendizadoRoute: typeof AuthedAgentesAutoaprendizadoRoute
  AuthedAgentesCustoRoute: typeof AuthedAgentesCustoRoute
  AuthedAgentesQualidadeRoute: typeof AuthedAgentesQualidadeRoute
  AuthedAgentesVisaoGeralRoute: typeof AuthedAgentesVisaoGeralRoute
  AuthedAgronomiaBancosDeDadosRoute: typeof AuthedAgronomiaBancosDeDadosRoute
  AuthedAgronomiaCatalogoRoute: typeof AuthedAgronomiaCatalogoRoute
  AuthedAgronomiaInsumosRoute: typeof AuthedAgronomiaInsumosRoute
  AuthedAgronomiaNovaFazendaRoute: typeof AuthedAgronomiaNovaFazendaRoute
  AuthedAgronomiaNovoProdutorRoute: typeof AuthedAgronomiaNovoProdutorRoute
  AuthedAgronomiaProdutoresRoute: typeof AuthedAgronomiaProdutoresRoute
  AuthedAgronomiaVisitaRoute: typeof AuthedAgronomiaVisitaRoute
  AuthedAgronomiaVisitaMultiRoute: typeof AuthedAgronomiaVisitaMultiRoute
  AuthedClientesIdRoute: typeof AuthedClientesIdRoute
  AuthedCrmListaRoute: typeof AuthedCrmListaRoute
  AuthedCrmMinhasTarefasRoute: typeof AuthedCrmMinhasTarefasRoute
  AuthedCrmRelatoriosRoute: typeof AuthedCrmRelatoriosRoute
  AuthedAgentesAgenteCanalRoute: typeof AuthedAgentesAgenteCanalRoute
  AuthedAgronomiaFazendasIdRoute: typeof AuthedAgronomiaFazendasIdRoute
  AuthedAgronomiaInsumosIdRoute: typeof AuthedAgronomiaInsumosIdRoute
  AuthedAgronomiaProdutoresCpfRoute: typeof AuthedAgronomiaProdutoresCpfRoute
  AuthedAgronomiaTalhoesIdRoute: typeof AuthedAgronomiaTalhoesIdRoute
  AuthedAgronomiaVisitaIdRoute: typeof AuthedAgronomiaVisitaIdRoute
  AuthedCrmRelatoriosOportunidadesRoute: typeof AuthedCrmRelatoriosOportunidadesRoute
  AuthedImoveisIdSoloRoute: typeof AuthedImoveisIdSoloRoute
  AuthedAgronomiaFazendasIdEditarRoute: typeof AuthedAgronomiaFazendasIdEditarRoute
  AuthedAgronomiaFazendasIdRelatorioRoute: typeof AuthedAgronomiaFazendasIdRelatorioRoute
  AuthedAgronomiaFazendasIdRevisarRoute: typeof AuthedAgronomiaFazendasIdRevisarRoute
  AuthedAgronomiaFazendasIdVisitaRoute: typeof AuthedAgronomiaFazendasIdVisitaRoute
  AuthedAgronomiaManejoIdCatRoute: typeof AuthedAgronomiaManejoIdCatRoute
  AuthedClientesIdRelatorioConformidadeDocumentalRoute: typeof AuthedClientesIdRelatorioConformidadeDocumentalRoute
  AuthedClientesIdRelatorioConformidadeResumidoRoute: typeof AuthedClientesIdRelatorioConformidadeResumidoRoute
  AuthedClientesIdRelatorioOnusGravamesRoute: typeof AuthedClientesIdRelatorioOnusGravamesRoute
  AuthedClientesIdRelatorioOperacoesCreditoRoute: typeof AuthedClientesIdRelatorioOperacoesCreditoRoute
  AuthedClientesIdRelatorioOrcamentoRoute: typeof AuthedClientesIdRelatorioOrcamentoRoute
  AuthedClientesIdRelatorioProdutividadeRoute: typeof AuthedClientesIdRelatorioProdutividadeRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAgentesRoute: AuthedAgentesRoute,
  AuthedAgentsRoute: AuthedAgentsRoute,
  AuthedAgronomiaRoute: AuthedAgronomiaRoute,
  AuthedAmbientalRoute: AuthedAmbientalRoute,
  AuthedClientesRoute: AuthedClientesRoute,
  AuthedConfigRoute: AuthedConfigRoute,
  AuthedCreditoRoute: AuthedCreditoRoute,
  AuthedCrmRoute: AuthedCrmRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDiagnosticoRoute: AuthedDiagnosticoRoute,
  AuthedGeoRoute: AuthedGeoRoute,
  AuthedGestaoRoute: AuthedGestaoRoute,
  AuthedHistoryRoute: AuthedHistoryRoute,
  AuthedJuridicoRoute: AuthedJuridicoRoute,
  AuthedPerfilRoute: AuthedPerfilRoute,
  AuthedSkillsRoute: AuthedSkillsRoute,
  AuthedUsuariosRoute: AuthedUsuariosRoute,
  AuthedAgentesAgenteRoute: AuthedAgentesAgenteRoute,
  AuthedAgentesAutoaprendizadoRoute: AuthedAgentesAutoaprendizadoRoute,
  AuthedAgentesCustoRoute: AuthedAgentesCustoRoute,
  AuthedAgentesQualidadeRoute: AuthedAgentesQualidadeRoute,
  AuthedAgentesVisaoGeralRoute: AuthedAgentesVisaoGeralRoute,
  AuthedAgronomiaBancosDeDadosRoute: AuthedAgronomiaBancosDeDadosRoute,
  AuthedAgronomiaCatalogoRoute: AuthedAgronomiaCatalogoRoute,
  AuthedAgronomiaInsumosRoute: AuthedAgronomiaInsumosRoute,
  AuthedAgronomiaNovaFazendaRoute: AuthedAgronomiaNovaFazendaRoute,
  AuthedAgronomiaNovoProdutorRoute: AuthedAgronomiaNovoProdutorRoute,
  AuthedAgronomiaProdutoresRoute: AuthedAgronomiaProdutoresRoute,
  AuthedAgronomiaVisitaRoute: AuthedAgronomiaVisitaRoute,
  AuthedAgronomiaVisitaMultiRoute: AuthedAgronomiaVisitaMultiRoute,
  AuthedClientesIdRoute: AuthedClientesIdRoute,
  AuthedCrmListaRoute: AuthedCrmListaRoute,
  AuthedCrmMinhasTarefasRoute: AuthedCrmMinhasTarefasRoute,
  AuthedCrmRelatoriosRoute: AuthedCrmRelatoriosRoute,
  AuthedAgentesAgenteCanalRoute: AuthedAgentesAgenteCanalRoute,
  AuthedAgronomiaFazendasIdRoute: AuthedAgronomiaFazendasIdRoute,
  AuthedAgronomiaInsumosIdRoute: AuthedAgronomiaInsumosIdRoute,
  AuthedAgronomiaProdutoresCpfRoute: AuthedAgronomiaProdutoresCpfRoute,
  AuthedAgronomiaTalhoesIdRoute: AuthedAgronomiaTalhoesIdRoute,
  AuthedAgronomiaVisitaIdRoute: AuthedAgronomiaVisitaIdRoute,
  AuthedCrmRelatoriosOportunidadesRoute: AuthedCrmRelatoriosOportunidadesRoute,
  AuthedImoveisIdSoloRoute: AuthedImoveisIdSoloRoute,
  AuthedAgronomiaFazendasIdEditarRoute: AuthedAgronomiaFazendasIdEditarRoute,
  AuthedAgronomiaFazendasIdRelatorioRoute:
    AuthedAgronomiaFazendasIdRelatorioRoute,
  AuthedAgronomiaFazendasIdRevisarRoute: AuthedAgronomiaFazendasIdRevisarRoute,
  AuthedAgronomiaFazendasIdVisitaRoute: AuthedAgronomiaFazendasIdVisitaRoute,
  AuthedAgronomiaManejoIdCatRoute: AuthedAgronomiaManejoIdCatRoute,
  AuthedClientesIdRelatorioConformidadeDocumentalRoute:
    AuthedClientesIdRelatorioConformidadeDocumentalRoute,
  AuthedClientesIdRelatorioConformidadeResumidoRoute:
    AuthedClientesIdRelatorioConformidadeResumidoRoute,
  AuthedClientesIdRelatorioOnusGravamesRoute:
    AuthedClientesIdRelatorioOnusGravamesRoute,
  AuthedClientesIdRelatorioOperacoesCreditoRoute:
    AuthedClientesIdRelatorioOperacoesCreditoRoute,
  AuthedClientesIdRelatorioOrcamentoRoute:
    AuthedClientesIdRelatorioOrcamentoRoute,
  AuthedClientesIdRelatorioProdutividadeRoute:
    AuthedClientesIdRelatorioProdutividadeRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PrintRouteChildren {
  PrintRelatorioOperacaoOpIdRoute: typeof PrintRelatorioOperacaoOpIdRoute
}

const PrintRouteChildren: PrintRouteChildren = {
  PrintRelatorioOperacaoOpIdRoute: PrintRelatorioOperacaoOpIdRoute,
}

const PrintRouteWithChildren = PrintRoute._addFileChildren(PrintRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  PrintRoute: PrintRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
